import { enableProdMode, isDevMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { getWhatsappShareRoute } from './app/shared/utils/whatsapp-share-redirect';
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://6e7b69ee7e2c855fe46f3c87321b8ab7@o4509752866701312.ingest.us.sentry.io/4510246071435264",
  enabled: isDevMode() ? false : true,
  integrations: [
    Sentry.replayIntegration(),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (environment.production) {
  enableProdMode();
}

const whatsappShareRoute = getWhatsappShareRoute(window.location.search);

if (whatsappShareRoute) {
  window.location.replace(
    `${window.location.origin}${window.location.pathname}#/${whatsappShareRoute}`,
  );
} else {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}
